import { useContext } from 'react';

import { IContextMenuItem } from '@smartshell/ui-kit';

import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { openConfirmDialog } from 'services/Confirmation';
import { TGameAccount, TGameAccountsGroup } from 'types';

import { GameAccountsContext } from '../../GameAccounts';
import s from './ContextMenuItems.module.scss';

export const useContextMenuItems = (
  group: TGameAccountsGroup,
  selectedAccounts: Array<TGameAccount>
): Array<IContextMenuItem<TGameAccount>> => {
  const { t } = useContext(LocalizationContext);
  const { deleteAccount, setAccountForEdit, openAccountManager, freeAccount } =
    useContext(GameAccountsContext) ?? {};
  const isAvailable = useIsFeatureAvailable('game_accounts');

  return [
    {
      key: 'edit',
      text: t('edit'),
      iconName: 'EditIcon',
      disabled: !isAvailable,
      onClick: (data) => {
        if (!setAccountForEdit || !openAccountManager) {
          return;
        }

        setAccountForEdit(data);
        openAccountManager(group);
      },
    },
    {
      key: 'free',
      text: t('accounts.free'),
      iconName: 'HostLogoutIcon',
      disabled: () =>
        selectedAccounts.some((account) => !account.busy || !isAvailable),
      onClick: () => {
        if (freeAccount && selectedAccounts) {
          selectedAccounts.forEach((account) => {
            if (account.busy) {
              freeAccount(account.id);
            }
          });
        }
      },
    },
    {
      key: 'delete',
      text: t('delete'),
      iconName: 'BucketIcon',
      disabled: !isAvailable,
      onClick: (data) =>
        openConfirmDialog(t, 'remove', {
          title: t('gameAccounts.delete'),
          message: t('gameAccounts.delete.message', data.login),
        }).then(({ status }) => {
          if (status === 'ACCEPTED' && deleteAccount) {
            deleteAccount(data.id);
          }
        }),
      className: s.remove,
    },
  ];
};
